import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { greys, font } from 'assets/themes/theme-default'
import { isTablet } from 'react-device-detect'

import { Tooltip } from 'core/components/ui'
import SVG from 'core/components/svg'
import { AREA } from '../constants'

const DefaultWrapper = styled.div`
  transform: ${props => props.idView === AREA.RIGHT_SIDE && 'scaleX(-1)'};
  overflow: visible;
  height: 180px;
  margin: 0 0 50px 0;
  ${isTablet && 'padding: 0 10px;'}
`
const Bkg = styled(SVG)`
  &&& {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: black;
    margin: 0 0 20px 0;
    overflow: visible;
  }
`

const Title = styled.h4`
  font-size: ${font.size.lg};
  color: ${greys.dark1};
  text-align: center;
  margin: 0 0 20px 0;
`

const Bkg2 = styled(SVG)`
  &&& {
    cursor: pointer;
    fill: transparent;
    stroke: transparent;
    overflow: visible;
    :hover {
      fill: ${props => props.theme.colors.color1.bg};
      opacity: 0.7;
      circle {
        fill: ${greys.dark1};
      }
      text {
        fill: ${greys.light4};
      }
    }
  }
`
const StyledText = styled.text`
  fill: ${greys.light4};
`

const StyledCircle = styled.circle`
  fill: ${props => props.theme.colors.color1.bg};
`

const RenderCar = props => {
  const { section, onSelect } = props

  const SvgDecoration = decorator => {
    const { circle, value } = decorator
    const { cx, cy, r, fontSize } = circle

    const y = (parseInt(cy, 10) + r / 4).toString()

    if (value !== 0) {
      return (
        <>
          <StyledCircle
            cx={cx}
            cy={cy}
            r={r}
            style={{
              transform: section.id === AREA.RIGHT_SIDE ? 'scaleX(-1)' : 'scaleX(1)'
            }}
          />
          <StyledText
            x={cx}
            y={y}
            textAnchor="middle"
            fontSize={fontSize}
            style={{
              transform: section.id === AREA.RIGHT_SIDE ? 'scaleX(-1)' : 'scaleX(1)'
            }}
          >
            {value}
          </StyledText>
        </>
      )
    }
    return null
  }

  return (
    <>
      {section && section.svg && (
        <>
          <Title>{section.label}</Title>
          <DefaultWrapper idView={section.id}>
            <Bkg svg={section.svg}>
              {section.zones.map(zone => {
                if (!zone) return null

                return (
                  <Tooltip title={zone.label} key={zone.id}>
                    <Bkg2 onClick={() => onSelect(zone.id)} svg={zone.svg}>
                      {zone.decorator && zone.decorator.value && SvgDecoration(zone.decorator)}
                    </Bkg2>
                  </Tooltip>
                )
              })}
            </Bkg>
          </DefaultWrapper>
        </>
      )}
    </>
  )
}

RenderCar.defaultProps = {
  onSelect: null
}

RenderCar.propTypes = {
  section: PropTypes.shape().isRequired,
  onSelect: PropTypes.func
}

export default RenderCar
